// src/pages/Workflows/Editor/utils/nodeDefinitions.js
// Definição estática de todos os tipos de nós do catálogo

// Verbosity do nó prompt_ia — valor guardado no payload (config.params.verbosity).
// 'normal' = comportamento por omissão do modelo; 'ultra' = verbosidade máxima.
// Payloads antigos não têm o campo: assume-se sempre VERBOSITY_DEFAULT.
export const VERBOSITY_DEFAULT = 'normal';
export const VERBOSITY_OPCOES = ['normal', 'ultra'];

export const NODE_DEFINITIONS = {
  formulario: {
    label: 'Formulário',
    categoria: 'entrada',
    cor: 'blue',
    enabled: true,
    inputs: [],
    outputType: 'json_object',
    descricao: 'Solicita dados ao utilizador antes de executar',
    campos_config: [
      // Nó especial: define campos de formulário dinamicamente
    ],
  },

  upload_ficheiros: {
    label: 'Upload Ficheiros',
    categoria: 'entrada',
    cor: 'blue',
    enabled: true,
    inputs: [],
    outputType: 'file_ref_list',
    descricao: 'Permite carregar um ou mais ficheiros',
  },

  dados_utilizador: {
    label: 'Dados Utilizador',
    categoria: 'entrada',
    cor: 'blue',
    enabled: true,
    inputs: [],
    outputType: 'json_object',
    descricao: 'Injeta dados do advogado logado (nome, nº ordem)',
  },

  transcrever_ficheiros: {
    label: 'Transcrever',
    categoria: 'processamento',
    cor: 'purple',
    enabled: true,
    inputs: [
      { nome: 'ficheiros', tipos_aceites: ['file_ref_list'], obrigatorio: true, label: 'Ficheiros' },
    ],
    outputType: 'transcricao_list',
    descricao: 'Transcreve áudio ou extrai texto de ficheiros',
  },

  prompt_ia: {
    label: 'Prompt IA',
    categoria: 'processamento',
    cor: 'purple',
    enabled: true,
    inputs: [
      { nome: 'sistema', tipos_aceites: ['text'], obrigatorio: false, label: 'Sistema' },
      {
        nome: 'mensagem',
        tipos_aceites: ['text', 'json_object', 'transcricao_list', 'json_list'],
        obrigatorio: true,
        label: 'Mensagem',
      },
    ],
    params_estaticos: [
      { nome: 'modelo', tipo: 'modelo_selector', label: 'Modelo', default: '' },
      { nome: 'usar_internet', tipo: 'booleano', label: 'Usar Internet', default: false },
      {
        nome: 'esforco_pensamento',
        tipo: 'lista',
        label: 'Esforço de Pensamento',
        opcoes: ['', 'low', 'medium', 'high'],
        default: '',
      },
      {
        nome: 'verbosity',
        tipo: 'lista',
        label: 'Verbosity',
        opcoes: [
          { valor: 'normal', label: 'Normal' },
          { valor: 'ultra',  label: 'Ultra' },
        ],
        default: VERBOSITY_DEFAULT,
      },
    ],
    outputType: 'text',
    descricao: 'Chamada configurável a um modelo de IA',
  },

  // ── Nós futuros (v2+) ─────────────────────────────────────────────────────

  conferir_documento: {
    label: 'Conferir Documento',
    categoria: 'processamento',
    cor: 'purple',
    enabled: false,
    inputs: [],
    outputType: 'json_object',
    descricao: 'Em breve',
  },

  gerar_conteudo_documento: {
    label: 'Gerar Conteúdo',
    categoria: 'processamento',
    cor: 'purple',
    enabled: false,
    inputs: [],
    outputType: 'text',
    descricao: 'Em breve',
  },

  analisar_caso: {
    label: 'Analisar Caso',
    categoria: 'processamento',
    cor: 'purple',
    enabled: false,
    inputs: [],
    outputType: 'json_object',
    descricao: 'Em breve',
  },

  pesquisar_jurisprudencia: {
    label: 'Pesquisar Jurisprudência',
    categoria: 'pesquisa',
    cor: 'green',
    enabled: true,
    inputs: [
      {
        nome: 'descricao',
        tipos_aceites: ['text', 'json_object', 'transcricao_list', 'json_list'],
        obrigatorio: true,
        label: 'Descrição do Caso',
      },
    ],
    params_estaticos: [
      { nome: 'limite', tipo: 'lista', label: 'Nº Resultados', opcoes: ['20', '40', '80'], default: '20' },
    ],
    outputType: 'json_list',
    descricao: 'Busca acórdãos relevantes por semântica + texto (busca híbrida)',
  },

  filtrar_acordaos: {
    label: 'Filtrar Acórdãos por Caso',
    categoria: 'pesquisa',
    cor: 'green',
    enabled: true,
    inputs: [
      { nome: 'acordaos',       tipos_aceites: ['json_list'],           obrigatorio: true,  label: 'Lista de Acórdãos' },
      { nome: 'descricao_caso', tipos_aceites: ['text', 'json_object'], obrigatorio: true,  label: 'Descrição do Caso' },
    ],
    params_estaticos: [
      { nome: 'k', tipo: 'lista', label: 'Nº de Acórdãos a Manter', opcoes: ['1', '2', '3'], default: '3' },
    ],
    outputType: 'json_list',
    descricao: 'Usa IA para filtrar e manter apenas os K acórdãos mais relevantes para o caso',
  },

  detalhar_acordaos: {
    label: 'Detalhar Acórdãos',
    categoria: 'pesquisa',
    cor: 'green',
    enabled: true,
    inputs: [
      { nome: 'acordaos', tipos_aceites: ['json_list'], obrigatorio: true, label: 'Lista de Acórdãos' },
    ],
    params_estaticos: [
      { nome: 'top_n', tipo: 'lista', label: 'Nº de Acórdãos a Detalhar', opcoes: ['3', '5', '10'], default: '5' },
    ],
    outputType: 'transcricao_list',
    descricao: 'Busca o texto integral dos acórdãos recebidos (compatível com Prompt IA)',
  },

  pesquisar_dados_cliente: {
    label: 'Dados do Cliente',
    categoria: 'pesquisa',
    cor: 'green',
    enabled: false,
    inputs: [],
    outputType: 'json_object',
    descricao: 'Em breve',
  },

  unificar_valores: {
    label: 'Unificar Valores',
    categoria: 'saida',
    cor: 'orange',
    enabled: true,
    inputs: [],          // dinâmicos — geridos via config.params.entradas
    inputs_dinamicos: true,
    outputType: 'text',
    descricao: 'Combina múltiplas saídas em texto formatado: **Nome**: Valor',
  },

  formatar_e_baixar_documento: {
    label: 'Gerar Documento',
    categoria: 'saida',
    cor: 'orange',
    enabled: true,
    inputs: [
      {
        nome: 'conteudo',
        tipos_aceites: ['text', 'transcricao_list', 'json_object', 'json_list'],
        obrigatorio: true,
        label: 'Conteúdo',
      },
      {
        nome: 'nome_ficheiro',
        tipos_aceites: ['text'],
        obrigatorio: false,
        label: 'Nome do Ficheiro (sem extensão)',
      },
    ],
    params_estaticos: [],
    outputType: 'file_ref_list',
    descricao: 'Gera um ficheiro .DOCX descarregável a partir do conteúdo',
  },
};

/**
 * Params iniciais de um nó recém-criado no canvas.
 */
export function paramsIniciaisNo(nodeType) {
  if (nodeType === 'unificar_valores') return { entradas: [] };
  if (nodeType === 'prompt_ia')        return { verbosity: VERBOSITY_DEFAULT };
  return {};
}

/**
 * Normaliza a config de um nó antes de gravar (retrocompatibilidade).
 *
 * Nós prompt_ia gravados antes da introdução do parâmetro `verbosity` não têm
 * o campo. Ao gravar, passa a ser sempre escrito com valor explícito — valores
 * desconhecidos são coagidos para VERBOSITY_DEFAULT. Nenhum outro campo é tocado.
 */
export function normalizarConfigNo(nodeType, config = {}) {
  if (nodeType !== 'prompt_ia') return config;

  const params = config.params || {};
  if (VERBOSITY_OPCOES.includes(params.verbosity)) return config;

  return { ...config, params: { ...params, verbosity: VERBOSITY_DEFAULT } };
}

// Grupos para exibição na paleta
export const CATEGORIAS_ORDEM = ['entrada', 'processamento', 'pesquisa', 'saida'];

export const CATEGORIA_LABELS = {
  entrada: 'Entrada',
  processamento: 'Processamento',
  pesquisa: 'Pesquisa',
  saida: 'Saída',
};

export const CATEGORIA_CORES = {
  entrada: '#3b82f6',
  processamento: '#8b5cf6',
  pesquisa: '#10b981',
  saida: '#f97316',
};
